import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

interface SearchModalProps {
  open: boolean;
  onClose: () => void;
}

const hotKeywords = ["顽皮的女朋友", "爱情", "喜剧", "悬疑", "科幻", "都市"];

export default function SearchModal({ open, onClose }: SearchModalProps) {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (open) {
      setKeyword("");
      const timer = window.setTimeout(() => inputRef.current?.focus(), 60);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [open]);

  useEffect(() => {
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    if (open) {
      document.addEventListener("keydown", handleKey);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  const submit = (value: string) => {
    const q = value.trim();
    onClose();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center pt-24 md:pt-32 px-4 bg-foreground-950/50 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="w-full max-w-2xl rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 animate-slide-down"
        onClick={(event) => event.stopPropagation()}
      >
        <form
          onSubmit={(event) => {
            event.preventDefault();
            submit(keyword);
          }}
          className="flex items-center gap-3"
        >
          <div className="flex-1 flex items-center gap-2 h-12 px-4 rounded-md border border-background-300 focus-within:border-primary-400 bg-background-50">
            <i className="ri-search-line text-lg text-foreground-500"></i>
            <input
              ref={inputRef}
              type="text"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索影视名称、主演或类型…"
              className="flex-1 h-full bg-transparent outline-none text-sm md:text-base text-foreground-950 placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="h-12 px-5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-heading text-sm tracking-wide hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            搜索
          </button>
        </form>

        <div className="mt-5">
          <p className="text-xs text-foreground-500 mb-2.5">热门搜索</p>
          <div className="flex flex-wrap gap-2">
            {hotKeywords.map((word) => (
              <button
                key={word}
                type="button"
                onClick={() => submit(word)}
                className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-sm hover:bg-accent-100 hover:text-accent-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                {word}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}